import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { AccountService } from 'gw-capability-gateway-account';
import { useModal } from '@jutro/components';
import { MLTagManagerService } from 'ml-portals-services-react';
import { ActivitiesService, PolicyService } from 'gw-capability-gateway';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import MLHistoryNotesComponent from '../MLHistoryNotesComponent/MLHistoryNotesComponent';
import MLActivitiesComponent from '../MLActvitiesComponent/MLActivitiesComponent';
import MLCompletedTransactionsComponent from '../MLCompletedTransactionsComponent/MLCompletedTransactionsComponent';
import metadata from './ActivitiesAndNotesComponent.metadata.json5';
import styles from './ActivitiesAndNotesComponent.module.scss';
import messages from './ActivitiesAndNotesComponent.messages';
import gatewayMessages from "../../gateway.messages";


function ActivitiesAndNotesComponent(props) {
    const modalApi = useModal();
    const {
        accountNumber,
        policyNumber,
        authHeader
    } = props;
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const [historyNotes, updateHistoryNotes] = useState([]);
    const [activities, updateActivities] = useState([]);
    const [activeTab, setActiveTab] = useState("notesTab");
    const completedTransactionsTabVisible = policyNumber !== undefined;

    const noteTopicTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('NoteTopicType');
    const getCategory = useCallback((note) => {
        if(note.topic) {
            const noteName = noteTopicTypelist.getCode(note.topic).name;
            const noteCategory = translator({
                id: noteName,
                defaultMessage: noteName
            });
            return noteCategory;
        }
        return translator(messages.categoryNotAvailable);
    }, [noteTopicTypelist, translator])

    const formatNotes = useCallback((notes) => {
        return notes.map((note) => {
            return {
                date: note.createdDate,
                categoryDescription: {
                    category: getCategory(note),
                    description: note.subject
                },
                policyNumber: note.policyNumber_ML,
                note: note,
                isNote: true
            };
        });
    }, [getCategory])

    const getHistoryAndNotes = useCallback(
        async () => {
            if (accountNumber) {
                try {
                    let historyAndNotes = [];

                    // Timeline Journey is a Post Upgrade item

                    // let historyAndNotes = await MLTimelineService.getTimelineByAccountNumber(accountNumber, authHeader);
                    // historyAndNotes = historyAndNotes.length ? historyAndNotes : [];
                    // if (historyAndNotes.length) {
                    //     const currentDate = LocalDateUtil.date2LocalDate(new Date());
                    //     historyAndNotes = historyAndNotes.filter((history) => LocalDateUtil.differenceInYears(currentDate, history.date) <= 1);
                    // }

                    // _.forEach(historyAndNotes, (note) => {
                    //     note.date = new Date().setFullYear(note.date.year, note.date.month, note.date.day);
                    // });

                    let notesData = await AccountService.getNotesForAccount(accountNumber, authHeader);
                    if (notesData.length) {
                        notesData = formatNotes(notesData); 
                    }
                    historyAndNotes = historyAndNotes.concat(notesData);

                    if (historyAndNotes.length) {
                        historyAndNotes.sort((a, b) => moment(b.date) - moment(a.date));
                    }
                    updateHistoryNotes(historyAndNotes);
                } catch (e) {
                    console.error(e);
                }
            } else {
                try {
                    const notesData = await PolicyService.getNotesForPolicy(policyNumber, authHeader);

                    if (notesData.length) {
                        const notesTimeline = formatNotes(notesData);
                        updateHistoryNotes(notesTimeline)
                    }

                  
                } catch (error) {
                    modalApi.showAlert({
                        title: gatewayMessages.modalError,
                        message: translator(messages.errorLoadingNotes),
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                }
            }


        },
        [accountNumber, policyNumber, authHeader, translator, formatNotes],
    )
    const onAddNote = () => {
        getHistoryAndNotes();
    }

    const getActivities = useCallback(
        async () => {
            let activities1;
            if (accountNumber) {
                activities1 = await ActivitiesService.getOpenActivitySummariesForAccount(accountNumber, authHeader);
            } else {
                activities1 = await ActivitiesService.getOpenActivitySummariesForPolicy(policyNumber, authHeader);
            }

            if (activities1) {
                activities1 = activities1.filter((activity) => activity.assignedTo !== 'Contact Manager - Contact Management')
            }
            
            updateActivities(activities1)
        }, [accountNumber, authHeader, policyNumber]);


    useEffect(() => {
        getHistoryAndNotes();
        getActivities();
    }, [getActivities, getHistoryAndNotes])

    const onAddActivity = () => {
        getActivities();
    }

    const overrideProps = {

        notesActivtyTabSet: {
            className: completedTransactionsTabVisible ? 'parentTabset ml-flex-tabs tripleTabset' : 'parentTabset ml-flex-tabs',
            activeTab,
            onTabChange: (tab) => {
                setActiveTab(tab);
                let mlTagManagerLinkClick;
                switch(tab){
                    case 'notesTab':
                        mlTagManagerLinkClick = `Policy Summary_Notes&Activities_${translator(messages.recentHistoryandNotesTab)}`
                        break;
                    case 'actvitiesTab':
                        mlTagManagerLinkClick = `Policy Summary_Notes&Activities_${translator(messages.pendingFollowUpsTab)}`
                        break;
                    case 'completedTransactionsTab':
                        mlTagManagerLinkClick = `Policy Summary_Notes&Activities_${translator(messages.completedTransactions)}`
                        break;
                    default:
                }
                if(mlTagManagerLinkClick){
                    MLTagManagerService.sendLinkClickEvent(mlTagManagerLinkClick)
                }
            }
        },
        notesTab: {
            heading: <div className={styles.tabText}>{translator(messages.recentHistoryandNotesTab)}</div>
        },
        actvitiesTab: {
            heading: <div className={styles.tabText}>{translator(messages.pendingFollowUpsTab)}</div>
        },
        completedTransactionsTab: {
            visible: completedTransactionsTabVisible,
            heading: <div className={styles.tabText}>{translator(messages.completedTransactions)}</div>
        },
        historyNotesComponent: {
            historyNotes: historyNotes,
            authHeader: authHeader,
            accountNumber: accountNumber,
            policyNumber: policyNumber,
            onAddNote: onAddNote
        },
        pendingFollowupComponent: {
            accountActivities: _.sortBy(activities, ['dueDate.year', 'dueDate.month', 'dueDate.day']),
            accountNumber: accountNumber,
            policyNumber: policyNumber,
            onAddActivity: onAddActivity
        },
        completedTransactionsComponent: {
            authHeader: authHeader,
            policyNumber: policyNumber
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            MLHistoryNotesComponent: MLHistoryNotesComponent,
            MLActivitiesComponent: MLActivitiesComponent,
            MLCompletedTransactionsComponent: MLCompletedTransactionsComponent
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
}

ActivitiesAndNotesComponent.propTypes = {
    accountNumber: PropTypes.string,
    policyNumber:  PropTypes.string,
    authHeader: PropTypes.shape({}).isRequired
};

ActivitiesAndNotesComponent.defaultProps = {

};

export default withRouter(withViewModelService(ActivitiesAndNotesComponent));
